import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Document, Page, pdfjs } from 'react-pdf';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import PageHeader from "../partials/PageHeader";
import PresetSection from './PresetSection';

import SlTab from '/node_modules/@shoelace-style/shoelace/dist/react/tab';
import SlTabGroup from '/node_modules/@shoelace-style/shoelace/dist/react/tab-group';
import SlTabPanel from '/node_modules/@shoelace-style/shoelace/dist/react/tab-panel';
import SlIcon from '/node_modules/@shoelace-style/shoelace/dist/react/icon';

import TemplateLineOrderContainer from './TemplateLineOrderContainer';

import { createBarcodeTemplate, previewBarcodeTemplate } from '../../redux/actions/barcodeTemplates';

const NewTemplateForm = ({ payload, newBarcodeTemplate, barcodeTemplates, newTemplate, loadPreview, settings }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  let navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [validTemplate, setValidTemplate] = useState(true);
  const [validationErrors, setValidationErrors] = useState([]);

  const [templateSaved, setTemplateSaved] = useState(true);
  const [templateForm, setTemplateForm] = useState({
    line_settings: [
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        position: 0
      },
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        position: 1
      },
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        position: 2
      },
      {
        render_strategy: 'truncate',
        font_size: 12,
        alignment: 'left',
        position: 3
      }
    ],

    page_definition: {
      page_width: 8.5,
      page_length: 11,
      page_x_margin: 0.25,
      page_y_margin: 0.25,
      rows: 15,
      columns: 3,
      label_x_padding: 0.1,
      label_y_padding: 0.1
    },

    barcode_enabled: true,
    barcode_line: 0,
    barcode_height_percent: 50,
    barcode_symbol_enabled: false,
    barcode_symbol_line: 3,
    barcode_symbol_priority: 7,
    barcode_symbol_label_enabled: false,
    barcode_symbol_label_override: '',
    product_name_enabled: false,
    product_name_line: 1,
    product_name_priority: 3,
    product_name_label_enabled: false,
    product_nameLabelOverride: '',
    option_1_enabled: false,
    option_1_line: 2,
    option_1_priority: 4,
    option_1_label_enabled: false,
    option_1_label_override: '',
    option_2_enabled: false,
    option_2_line: 2,
    option_2_priority: 5,
    option_2_label_enabled: false,
    option_2_label_override: '',
    option_3_enabled: false,
    option_3_line: 2,
    option_3_priority: 6,
    option_3_label_enabled: false,
    option_3_label_override: '',
    price_enabled: false,
    price_line: 2,
    price_priority: 2,
    price_label_enabled: false,
    price_label_override: '',

    taxed_price_enabled: false,
    taxed_price_line: 2,
    taxed_price_priority: 9,
    taxed_price_label_enabled: false,
    taxed_price_label_override: '',

    brand_enabled: false,
    brand_line: 1,
    brand_priority: 0,
    brand_label_enabled: false,
    brand_label_override: '',
    rotate: false,
    print_type: 'roll',
    length: 1,
    width: 3,
    size_measurement: 'in',

    store_logo_enabled: false,
    store_logo_line: 0,
    store_logo_height_percent: 50,

    arbitrary_text_enabled: false,
    arbitrary_text_line: 0,
    arbitrary_text_priority: 8,
    arbitrary_text_label_enabled: false,
    arbitrary_text_label_override: '',
  });

  const [templateName, setTemplateName] = useState('');
  const [rotate, setRotate] = useState(false);
  const [printType, setPrintType] = useState('roll');
  const [length, setLength] = useState(1);
  const [width, setWidth] = useState(3);
  const [sizeMeasurement, setSizeMeasurement] = useState('in');

  const [lineCount, setLineCount] = useState(4);
  const [lineSettings, setLineSettings] = useState([
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      position: 0
    },
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      position: 1
    },
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      position: 2
    },
    {
      render_strategy: 'truncate',
      font_size: 12,
      alignment: 'left',
      position: 3
    }
  ]);

  const [pageWidth, setPageWidth] = useState(8.5);
  const [pageLength, setPageLength] = useState(11);
  const [pageXMargin, setPageXMargin] = useState(0.25);
  const [pageYMargin, setPageYMargin] = useState(0.25);
  const [pageRows, setPageRows] = useState(15);
  const [pageColumns, setPageColumns] = useState(3);
  const [pageLabelXPadding, setPageLabelXPadding] = useState(0.1);
  const [pageLabelYPadding, setPageLabelYPadding] = useState(0.1);

  const [barcodeEnabled, setBarcodeEnabled] = useState(true);
  const [barcodeLine, setBarcodeLine] = useState(0);
  const [barcodeHeightPercent, setBarcodeHeightPercent] = useState(50);

  const [storeLogoEnabled, setStoreLogoEnabled] = useState(false);
  const [storeLogoLine, setStoreLogoLine] = useState(0);
  const [storeLogoHeightPercent, setStoreLogoHeightPercent] = useState(50);

  const [barcodeSymbolEnabled, setBarcodeSymbolEnabled] = useState(false);
  const [barcodeSymbolLine, setBarcodeSymbolLine] = useState(3);
  const [barcodeSymbolPriority, setBarcodeSymbolPriority] = useState(7);
  const [barcodeSymbolLabelEnabled, setBarcodeSymbolLabelEnabled] = useState(false);
  const [barcodeSymbolLabelOverride, setBarcodeSymbolLabelOverride] = useState('');

  const [productNameEnabled, setProductNameEnabled] = useState(false);
  const [productNameLine, setProductNameLine] = useState(1);
  const [productNamePriority, setProductNamePriority] = useState(3);
  const [productNameLabelEnabled, setProductNameLabelEnabled] = useState(false);
  const [productNameLabelOverride, setProductNameLabelOverride] = useState('');

  const [optionOneEnabled, setOptionOneEnabled] = useState(false);
  const [optionOneLine, setOptionOneLine] = useState(2);
  const [optionOnePriority, setOptionOnePriority] = useState(4);
  const [optionOneLabelEnabled, setOptionOneLabelEnabled] = useState(false);
  const [optionOneLabelOverride, setOptionOneLabelOverride] = useState('');

  const [optionTwoEnabled, setOptionTwoEnabled] = useState(false);
  const [optionTwoLine, setOptionTwoLine] = useState(2);
  const [optionTwoPriority, setOptionTwoPriority] = useState(5);
  const [optionTwoLabelEnabled, setOptionTwoLabelEnabled] = useState(false);
  const [optionTwoLabelOverride, setOptionTwoLabelOverride] = useState('');

  const [optionThreeEnabled, setOptionThreeEnabled] = useState(false);
  const [optionThreeLine, setOptionThreeLine] = useState(2);
  const [optionThreePriority, setOptionThreePriority] = useState(6);
  const [optionThreeLabelEnabled, setOptionThreeLabelEnabled] = useState(false);
  const [optionThreeLabelOverride, setOptionThreeLabelOverride] = useState('');

  const [priceEnabled, setPriceEnabled] = useState(false);
  const [priceLine, setPriceLine] = useState(2);
  const [pricePriority, setPricePriority] = useState(2);
  const [priceLabelEnabled, setPriceLabelEnabled] = useState(false);
  const [priceLabelOverride, setPriceLabelOverride] = useState('');

  const [taxedPriceEnabled, setTaxedPriceEnabled] = useState(false);
  const [taxedPriceLine, setTaxedPriceLine] = useState(2);
  const [taxedPricePriority, setTaxedPricePriority] = useState(9);
  const [taxedPriceLabelEnabled, setTaxedPriceLabelEnabled] = useState(false);
  const [taxedPriceLabelOverride, setTaxedPriceLabelOverride] = useState('');

  const [brandEnabled, setBrandEnabled] = useState(false);
  const [brandLine, setBrandLine] = useState(1);
  const [brandPriority, setBrandPriority] = useState(0);
  const [brandLabelEnabled, setBrandLabelEnabled] = useState(false);
  const [brandLabelOverride, setBrandLabelOverride] = useState('');

  const [arbitraryTextEnabled, setArbitraryTextEnabled] = useState(false);
  const [arbitraryTextLine, setArbitraryTextLine] = useState(3);
  const [arbitraryTextPriority, setArbitraryTextPriority] = useState(8);
  const [arbitraryTextLabelEnabled, setArbitraryTextLabelEnabled] = useState(true);
  const [arbitraryTextLabelOverride, setArbitraryTextLabelOverride] = useState('');


  const [activePreviewuri, setActivePreviewUri] = useState(null);

  const [previewGenerating, setPreviewGenerating] = useState(false);
  const [enqueuePreviewGeneration, setEnqueuePreviewGeneration] = useState(null);

  useEffect(() => {
    handlePreview(templateForm, null);
  }, []);

  useEffect(() => {
    if(newTemplate) { navigate(-1) };
  }, [newTemplate]);

  useEffect(() => {
    let updatedTemplate = templateForm;
    updatedTemplate['line_settings'] = lineSettings;

    handlePreview(updatedTemplate, null);
  }, [lineSettings]);

  const changeLineCount = (event) => {
    let updatedTemplate = templateForm;
    let updatedLineSettings = lineSettings;

    let newLineCount = parseInt(event);

    let isIncrease = newLineCount > (lineCount || 0);

    if(isIncrease) {
      let difference = newLineCount - (lineCount || 0);

      for(let i = 0; i < difference; i++){
        updatedLineSettings.push({
          render_strategy: 'truncate',
          font_size: 12,
          alignment: 'left',
          position: (lineCount || 0) + i
        })
      }
    } else {
      let difference = (lineCount || 0) - newLineCount;

      for(let i = 0; i < difference; i++){
        updatedLineSettings.pop();
      }
    }

    setLineCount(newLineCount);

    updatedTemplate['line_count'] = newLineCount;
    updatedTemplate['line_settings'] = updatedLineSettings;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(updatedTemplate, null);
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  const setNumeric = (setField, event) => {
    let value = event.target.value;
    let updatedTemplate = templateForm;
    let valueNumeric = value.replace(/[^\d.-]+/g, '');

    if(valueNumeric > 999.9) {
      valueNumeric = 999.9
    }

    setField(valueNumeric);
    updatedTemplate[event.target.id] = valueNumeric;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    handlePreview(updatedTemplate, null);
  }

  const setInteger = (setField, event) => {
    let value = event.target.value;
    let updatedTemplate = templateForm;
    let valueNumeric = parseInt(value) || 0;

    if(valueNumeric > 99) {
      valueNumeric = 99
    }

    setField(valueNumeric);
    updatedTemplate[event.target.id] = valueNumeric;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }

    handlePreview(updatedTemplate, null);
  }

  const switchBoolean = (setField, field, key) => {
    let updatedTemplate = templateForm;
    updatedTemplate[key] = !field;

    setField(!field);
    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(updatedTemplate, null);
  }

  const handleSwitchRotate = () => {
    let updatedTemplate = templateForm;
    updatedTemplate['rotate'] = !rotate;

    setRotate(!rotate);
    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
    
    handlePreview(updatedTemplate, null);
  }

  const setMeasurements = (event) => {
    let measurement = event.target.value;

    let updatedTemplate = templateForm;
    updatedTemplate['size_measurement'] = measurement;

    setTemplateForm(updatedTemplate);

    setSizeMeasurement(measurement);

    handlePreview(updatedTemplate, null);
    setTemplateSaved(false);
  }

  const setFieldValue = (setField, event) => {
    let value = event.target.value;

    let updatedTemplate = templateForm;
    updatedTemplate[event.target.id] = value;
    setTemplateForm(updatedTemplate);
    setField(value);
    setTemplateSaved(false);

    handlePreview(updatedTemplate, null);
  }

  const setPriority = (setFunction, value, key) => {
    let updatedTemplate = templateForm;

    setFunction(value);

    updatedTemplate[key] = value;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);

    handlePreview(updatedTemplate, null);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    newBarcodeTemplate(payload, templateForm);
    setTemplateSaved(true);
  }

  const handlePreview = (templateForm, values) => {
    validateTemplate(templateForm);

    console.log(templateForm);
    console.log(values);

    if(!previewGenerating) {
      setPreviewGenerating(true);
      setEnqueuePreviewGeneration(null);
      const timeoutId = setTimeout(() => {
        loadPreview(payload, templateForm, values);
      }, 500);
      return () => clearTimeout(timeoutId);
    } else {
      setEnqueuePreviewGeneration(templateForm);
    }
  }

  const readyPreview = () => {
    setPreviewGenerating(false);
    if(enqueuePreviewGeneration) {
      handlePreview(enqueuePreviewGeneration, null);
    }
  }

  const setRenderStrategy = (position, e) => {
    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, render_strategy: e } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setFontSize = (position, e) => {
    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, font_size: e.target.value.replace(/[^\d-]+/g, '') } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setAlignment = (position, e) => {
    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, alignment: e.target.value } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const increasePriority = (element, lineElements) => {
    lineElements.sort((a,b) => a.last_nom - b.last_nom);
    let elementIndex = lineElements.findIndex((el) => el === element);

    if(elementIndex === 0) { return; }

    let el = lineElements[elementIndex - 1];
    let elementNewPriority = lineElements[elementIndex - 1].priority;
    let elementOldPriority = element.priority;

    if(element.element === 'Barcode Symbol') { setPriority(setBarcodeSymbolPriority, elementNewPriority, 'barcode_symbol_priority') }
    if(element.element === 'Product Name') { setPriority(setProductNamePriority, elementNewPriority, 'product_name_priority') }
    if(element.element === 'Variation Option 1') { setPriority(setOptionOnePriority, elementNewPriority, 'option_1_priority') }
    if(element.element === 'Variation Option 2') { setPriority(setOptionTwoPriority, elementNewPriority, 'option_2_priority') }
    if(element.element === 'Variation Option 3') { setPriority(setOptionThreePriority, elementNewPriority, 'option_3_priority') }
    if(element.element === 'Price') { setPriority(setPricePriority, elementNewPriority, 'price_priority') }

    if(element.element === 'Taxed Price') { setPriority(setTaxedPricePriority, elementNewPriority, 'taxed_price_priority') }

    if(element.element === 'Brand') { setPriority(setBrandPriority, elementNewPriority, 'brand_priority') }
    if(element.element === 'Arbitrary Text') { setPriority(setArbitraryTextPriority, elementNewPriority, 'arbitrary_text_priority') }

    if(el.element === 'Barcode Symbol') { setPriority(setBarcodeSymbolPriority, elementOldPriority, 'barcode_symbol_priority') }
    if(el.element === 'Product Name') { setPriority(setProductNamePriority, elementOldPriority, 'product_name_priority') }
    if(el.element === 'Variation Option 1') { setPriority(setOptionOnePriority, elementOldPriority, 'option_1_priority') }
    if(el.element === 'Variation Option 2') { setPriority(setOptionTwoPriority, elementOldPriority, 'option_2_priority') }
    if(el.element === 'Variation Option 3') { setPriority(setOptionThreePriority, elementOldPriority, 'option_3_priority') }
    if(el.element === 'Price') { setPriority(setPricePriority, elementOldPriority, 'price_priority') }

    if(el.element === 'Taxed Price') { setPriority(setTaxedPricePriority, elementOldPriority, 'taxed_price_priority') }

    if(el.element === 'Brand') { setPriority(setBrandPriority, elementOldPriority, 'brand_priority') }
    if(el.element === 'Arbitrary Text') { setPriority(setArbitraryTextPriority, elementOldPriority, 'arbitrary_text_priority') }

    let movedElement = document.querySelector(`#line-element-${elementNewPriority}`);

    movedElement.classList.add("blink-action");

    setTimeout(() => {
      movedElement.classList.remove("blink-action");
    }, 1000);
  }
  
  const decreasePriority = (element, lineElements) => {
    lineElements.sort((a,b) => a.last_nom - b.last_nom);
    let elementIndex = lineElements.findIndex((el) => el === element);

    if(elementIndex === (lineElements.length - 1)) { return; }

    let el = lineElements[elementIndex + 1];
    let elementNewPriority = lineElements[elementIndex + 1].priority;
    let elementOldPriority = element.priority;

    if(element.element === 'Barcode Symbol') { setPriority(setBarcodeSymbolPriority, elementNewPriority, 'barcode_symbol_priority') }
    if(element.element === 'Product Name') { setPriority(setProductNamePriority, elementNewPriority, 'product_name_priority') }
    if(element.element === 'Variation Option 1') { setPriority(setOptionOnePriority, elementNewPriority, 'option_1_priority') }
    if(element.element === 'Variation Option 2') { setPriority(setOptionTwoPriority, elementNewPriority, 'option_2_priority') }
    if(element.element === 'Variation Option 3') { setPriority(setOptionThreePriority, elementNewPriority, 'option_3_priority') }
    if(element.element === 'Price') { setPriority(setPricePriority, elementNewPriority, 'price_priority') }

    if(element.element === 'Taxed Price') { setPriority(setTaxedPricePriority, elementNewPriority, 'taxed_price_priority') }

    if(element.element === 'Brand') { setPriority(setBrandPriority, elementNewPriority, 'brand_priority') }
    if(element.element === 'Arbitrary Text') { setPriority(setArbitraryTextPriority, elementNewPriority, 'arbitrary_text_priority') }

    if(el.element === 'Barcode Symbol') { setPriority(setBarcodeSymbolPriority, elementOldPriority, 'barcode_symbol_priority') }
    if(el.element === 'Product Name') { setPriority(setProductNamePriority, elementOldPriority, 'product_name_priority') }
    if(el.element === 'Variation Option 1') { setPriority(setOptionOnePriority, elementOldPriority, 'option_1_priority') }
    if(el.element === 'Variation Option 2') { setPriority(setOptionTwoPriority, elementOldPriority, 'option_2_priority') }
    if(el.element === 'Variation Option 3') { setPriority(setOptionThreePriority, elementOldPriority, 'option_3_priority') }
    if(el.element === 'Price') { setPriority(setPricePriority, elementOldPriority, 'price_priority') }

    if(el.element === 'Taxed Price') { setPriority(setTaxedPricePriority, elementOldPriority, 'taxed_price_priority') }

    if(el.element === 'Brand') { setPriority(setBrandPriority, elementOldPriority, 'brand_priority') }
    if(el.element === 'Arbitrary Text') { setPriority(setArbitraryTextPriority, elementOldPriority, 'arbitrary_text_priority') }

    let movedElement = document.querySelector(`#line-element-${elementNewPriority}`);

    movedElement.classList.add("blink-action");

    setTimeout(() => {
      movedElement.classList.remove("blink-action");
    }, 1000);
  }

  const setPageValue = (setField, event) => {
    let value = event.target.value;
    let updatedTemplate = templateForm;
    let valueNumeric = value.replace(/[^\d.-]+/g, '') || 0.0;

    if(valueNumeric > 999.9) {
      valueNumeric = 999.9
    }

    let valueInteger = parseInt(value) || 0;

    if(['rows', 'columns'].includes(event.target.id)) {
      setField(valueInteger);
      updatedTemplate['page_definition'][event.target.id] = valueInteger;
    } else {
      setField(valueNumeric);
      updatedTemplate['page_definition'][event.target.id] = parseFloat(valueNumeric);
    }

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    validateTemplate(updatedTemplate);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const handleSwitchPageType = (event) => {
    let updatedTemplate = templateForm;

    let newType = event.target.value;

    console.log(newType);
    updatedTemplate['print_type'] = newType;
    setPrintType(newType);

    if (newType === 'sheet') {
      setRotate(false);
      updatedTemplate['rotate'] = false;
    }

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);

    handlePreview(updatedTemplate, null);
  }

  const validateTemplate = (templateForm) => {
    let valid = true;
    let updatedValidationErrors = [];

    // Must have a template name
    if (!templateForm['template_name']) {
      valid = false;
      updatedValidationErrors.push('Template Name Missing.');
    }

    // If it's a sheet, it must have page length, page width, rows and columns
    if (templateForm['print_type'] === 'sheet') {
      if (!templateForm.page_definition.page_length || !templateForm.page_definition.page_width || !templateForm.page_definition.columns || !templateForm.page_definition.rows) {
        valid = false;
        updatedValidationErrors.push('Sheets must have defined page length, page width, columns and rows.');
      }
    }

    setValidationErrors(updatedValidationErrors);
    setValidTemplate(valid);
  }

  return(
    <>
      <PageHeader stripeBackground='#5bc6cc' helpLink="ecwid/manage-barcode-label-templates/" />
      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">New Label Template</div>
              </div>
              <div className="named-area__description">
                <p>Name the new template, and define the label's size and included information with the options here. As changes are made, a preview of the template will appear in the blue box below.</p>
                <p>Changing the number of lines in the template will change the lines available in the "Line" dropdowns in the "Label Parts" section, and will change the available lines on the left of the "Line Settings" section.</p>
                <p>To see a template with a given product or variation, save the template, find the product in the "Labels + Print" section's Catalog Search, then click the item's "Preview Labels" button.</p>
                <p>Note: if text extends beyond the edge of a label, it will not be printed. If you need the text to appear, consider shrinking the font size, or changing labels.</p>
                <div className="preview-container preview-container--blue">
                  <div className="spacing--mb1">Preview</div>
                  { barcodeTemplates.previewUri &&
                    <Document className="pdf-document" file={{ url: barcodeTemplates.previewUri }} loading={<LoadingSpinner />} onLoadSuccess={() => readyPreview()}>
                      <Page
                        className="pdf-page"
                        pageNumber={1} 
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    </Document>
                  }
                </div>
              </div>
            </div>
            <div className="named-area__body">
              
              <div className="a-card-stack">

                <div className="a-card a-card--compact">
                  <div className="a-card__paddings">
                    <h1>New Template</h1> 
                    <h2>Barcode Template Options</h2>

                      <div className="a-card a-card--normal">
                        <div className="a-card__paddings">
                          <div className="fieldset full-width">
                            <div className="fieldset__title">Template Name</div>
                            <div className={ templateName ? "field field--medium field--filled" : "field field--medium"}>
                              <span className="fieldset__svg-icon"></span>
                              <label className="field__label">Template Name</label>
                              
                              { !submitted && <input id="template_name" type="text" value={templateName} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setTemplateName, e)} className="field__input" tabindex="4" maxlength="64" /> }
                              { submitted && <input id="template_name" type="text" value={templateName} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setTemplateName, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                              
                              <div className="field__placeholder">Template Name</div>
                              <span className="field-state--success"></span>
                              <span className="field-state--close"></span>
                            </div>
                            <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                          </div>  
                        </div>
                      </div>

                      <div className="a-card a-card--normal">
                        <div className="a-card__paddings">
                          <h3>Print Type</h3>
                          <div className="graphic-radio-group">
                            <div className="graphic-radio-group__items">
                              <div className="graphic-radio graphic-radio--small">
                                <label className="graphic-radio__label">
                                  <input 
                                    type="radio" 
                                    name="action-type" 
                                    value="roll" 
                                    checked={printType === "roll"}
                                    className="graphic-radio__input" 
                                    onChange={ (e) => handleSwitchPageType(e) }
                                  />
                                  <div className="graphic-radio__icon">
                                    <span className="svg-icon">
                                      <svg fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
                                         viewBox="0 0 512 512">
                                      <g>
                                        <g>
                                          <path d="M468.647,279.577c-1.038-1.122-2.095-2.22-3.16-3.306V157.823c0-30.631-24.921-55.552-55.552-55.552H0v250.96h227.818
                                            c3.703,12.895,5.69,26.746,5.69,41.289v15.209H512v-15.209C512,350.626,496.604,309.806,468.647,279.577z M30.417,322.814V132.688
                                            h379.518c13.859,0,25.135,11.276,25.135,25.135v94.571c-9.223-5.467-19.016-9.907-29.246-13.28v-49.615H59.663v72.28h49.15
                                            c45.904,0,84.511,23.799,106.11,61.034H30.417z M375.407,219.917v12.52h-0.001c-6.083-0.705-12.261-1.074-18.518-1.074H108.814
                                            H90.081v-11.446H375.407z M263.303,379.312c-3.136-38.057-18.031-73.028-42.731-99.734c-6.072-6.566-12.631-12.508-19.61-17.798
                                            h155.928c66.241,0,117.303,49.548,123.957,117.532H263.303z"/>
                                        </g>
                                      </g>
                                      </svg>
                                    </span>
                                    <div className="graphic-radio__bg"></div>
                                  </div>
                                  <span className="graphic-radio__title">Roll</span>
                                </label>
                              </div>
                              <div className="graphic-radio graphic-radio--small">
                                <label className="graphic-radio__label">
                                  <input 
                                    type="radio" 
                                    name="action-type" 
                                    value="sheet" 
                                    checked={printType === "sheet"}
                                    className="graphic-radio__input" 
                                    onChange={ (e) => handleSwitchPageType(e) }
                                  />
                                  <div className="graphic-radio__icon">
                                    <span className="svg-icon">
                                      <svg fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
                                         viewBox="0 0 512 512">
                                      <g>
                                        <g>
                                          <path d="M316.823,341.334H195.178c-4.512,0-8.17,3.657-8.17,8.17v121.645c0,4.513,3.658,8.17,8.17,8.17h121.646
                                            c4.512,0,8.17-3.657,8.17-8.17V349.504C324.994,344.991,321.336,341.334,316.823,341.334z M308.652,462.979H203.348V357.674
                                            h105.304V462.979z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M503.83,0H8.17C3.658,0,0,3.657,0,8.17V239.66c0,4.513,3.658,8.17,8.17,8.17s8.17-3.657,8.17-8.17V16.34H495.66V495.66
                                            H16.34V272.34c0-4.513-3.658-8.17-8.17-8.17S0,267.827,0,272.34V503.83c0,4.513,3.658,8.17,8.17,8.17h495.66
                                            c4.512,0,8.17-3.657,8.17-8.17V8.17C512,3.657,508.342,0,503.83,0z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M316.822,187.006H195.178c-4.512,0-8.17,3.657-8.17,8.17v121.647c0,4.513,3.658,8.17,8.17,8.17h121.645
                                            c4.512,0,8.17-3.657,8.17-8.17V195.177C324.993,190.663,321.334,187.006,316.822,187.006z M308.652,308.653H203.348V203.347
                                            h105.304V308.653z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M316.822,32.681H195.178c-4.512,0-8.17,3.657-8.17,8.17v121.645c0,4.513,3.658,8.17,8.17,8.17h121.645
                                            c4.512,0,8.17-3.657,8.17-8.17V40.851C324.993,36.338,321.334,32.681,316.822,32.681z M308.652,154.326H203.348V49.021h105.304
                                            V154.326z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M162.497,187.006H40.851c-4.512,0-8.17,3.657-8.17,8.17v121.647c0,4.513,3.658,8.17,8.17,8.17h121.646
                                            c4.512,0,8.17-3.657,8.17-8.17V195.177C170.667,190.663,167.009,187.006,162.497,187.006z M154.327,308.653H49.021V203.347
                                            h105.305V308.653z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M471.149,32.681H349.503c-4.512,0-8.17,3.657-8.17,8.17v121.645c0,4.513,3.658,8.17,8.17,8.17h121.646
                                            c4.512,0,8.17-3.657,8.17-8.17V40.851C479.319,36.338,475.661,32.681,471.149,32.681z M462.979,154.326H357.673V49.021h105.305
                                            V154.326z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M471.149,187.006H349.503c-4.512,0-8.17,3.657-8.17,8.17v121.647c0,4.513,3.658,8.17,8.17,8.17h121.646
                                            c4.512,0,8.17-3.657,8.17-8.17V195.177C479.319,190.663,475.661,187.006,471.149,187.006z M462.979,308.653H357.673V203.347
                                            h105.305V308.653z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M471.149,341.334H349.503c-4.512,0-8.17,3.657-8.17,8.17v121.645c0,4.513,3.658,8.17,8.17,8.17h121.646
                                            c4.512,0,8.17-3.657,8.17-8.17V349.504C479.319,344.991,475.661,341.334,471.149,341.334z M462.979,462.979H357.673V357.674
                                            h105.305V462.979z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M162.497,341.334H40.851c-4.512,0-8.17,3.657-8.17,8.17v121.645c0,4.513,3.658,8.17,8.17,8.17h121.646
                                            c4.512,0,8.17-3.657,8.17-8.17V349.504C170.667,344.991,167.009,341.334,162.497,341.334z M154.327,462.979H49.021V357.674
                                            h105.305V462.979z"/>
                                        </g>
                                      </g>
                                      <g>
                                        <g>
                                          <path d="M162.497,32.681H40.851c-4.512,0-8.17,3.657-8.17,8.17v121.645c0,4.513,3.658,8.17,8.17,8.17h121.646
                                            c4.512,0,8.17-3.657,8.17-8.17V40.851C170.667,36.338,167.009,32.681,162.497,32.681z M154.327,154.326H49.021V49.021h105.305
                                            V154.326z"/>
                                        </g>
                                      </g>
                                      </svg>
                                    </span>
                                    <div className="graphic-radio__bg"></div>
                                  </div>
                                  <span className="graphic-radio__title">Sheet</span>
                                </label>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                      </div>

                      { printType === 'sheet' &&
                        <div className="a-card a-card--normal">
                          <div className="a-card__paddings">
                            <h3>Page Options</h3>
                            <div className="flex-container padding-15 a-card__darken">
                              <div className="flex-1">
                                <h4>Use Template Preset</h4>
                                <PresetSection
                                  setTemplateForm={setTemplateForm}
                                  templateForm={templateForm}
                                  setLength={setLength}
                                  setWidth={setWidth}
                                  setPageWidth={setPageWidth}
                                  setPageLength={setPageLength}
                                  setPageXMargin={setPageXMargin}
                                  setPageYMargin={setPageYMargin}
                                  setPageRows={setPageRows}
                                  setPageColumns={setPageColumns}
                                  setPageLabelXPadding={setPageLabelXPadding}
                                  setPageLabelYPadding={setPageLabelYPadding}
                                  setSizeMeasurement={setSizeMeasurement}
                                  handlePreview={handlePreview}
                                />
                              </div>
                              <div className="flex-1 left-15">
                                
                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Page Width</div>
                                  <div className={ (pageWidth !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Page Width</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_width" type="text" value={pageWidth} onChange={(e) => setPageValue(setPageWidth, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_width" type="text" value={pageWidth} onChange={(e) => setPageValue(setPageWidth, e)} /> }
                                    
                                    <div className="field__placeholder">Page Width</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>

                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Page Length</div>
                                  <div className={ (pageLength !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Page Length</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_length" type="text" value={pageLength} onChange={(e) => setPageValue(setPageLength, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_length" type="text" value={pageLength} onChange={(e) => setPageValue(setPageLength, e)} /> }
                                    
                                    <div className="field__placeholder">Page Length</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>

                                <div className="fieldset full-width">
                                  <div className="fieldset__title">X Margin</div>
                                  <div className={ (pageXMargin !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">X Margin</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_x_margin" type="text" value={pageXMargin} onChange={(e) => setPageValue(setPageXMargin, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_x_margin" type="text" value={pageXMargin} onChange={(e) => setPageValue(setPageXMargin, e)} /> }
                                    
                                    <div className="field__placeholder">X Margin</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>

                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Y Margin</div>
                                  <div className={ (pageYMargin !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Y Margin</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_y_margin" type="text" value={pageYMargin} onChange={(e) => setPageValue(setPageYMargin, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="page_y_margin" type="text" value={pageYMargin} onChange={(e) => setPageValue(setPageYMargin, e)} /> }
                                    
                                    <div className="field__placeholder">Y Margin</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>

                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Page Rows</div>
                                  <div className={ (pageRows !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Page Rows</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="rows" type="text" value={pageRows} onChange={(e) => setPageValue(setPageRows, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="rows" type="text" value={pageRows} onChange={(e) => setPageValue(setPageRows, e)} /> }
                                    
                                    <div className="field__placeholder">Page Rows</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>
  
                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Page Columns</div>
                                  <div className={ (pageColumns !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Page Columns</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="columns" type="text" value={pageColumns} onChange={(e) => setPageValue(setPageColumns, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="columns" type="text" value={pageColumns} onChange={(e) => setPageValue(setPageColumns, e)} /> }
                                    
                                    <div className="field__placeholder">Page Columns</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>

                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Label X Padding</div>
                                  <div className={ (pageLabelXPadding !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Label X Padding</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="label_x_padding" type="text" value={pageLabelXPadding} onChange={(e) => setPageValue(setPageLabelXPadding, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="label_x_padding" type="text" value={pageLabelXPadding} onChange={(e) => setPageValue(setPageLabelXPadding, e)} /> }
                                    
                                    <div className="field__placeholder">Label X Padding</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>

                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Label Y Padding</div>
                                  <div className={ (pageLabelYPadding !== null) ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Label Y Padding</label>
                                    
                                    { !submitted && <input className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="label_y_padding" type="text" value={pageLabelYPadding} onChange={(e) => setPageValue(setPageLabelYPadding, e)} /> }
                                    { submitted && <input disabled className="field__input" tabindex="4" maxlength="64" onFocus={focus} onBlur={blur} id="label_y_padding" type="text" value={pageLabelYPadding} onChange={(e) => setPageValue(setPageLabelYPadding, e)} /> }
                                    
                                    <div className="field__placeholder">Label Y Padding</div>
                                    <span className="field-state--success"></span>
                                    <span className="field-state--close"></span>
                                  </div>
                                  <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      <div className="a-card a-card--normal">
                        <div className="a-card__paddings">

                          <div className="fieldset full-width">
                            <h3>Label Dimensions</h3>

                            <div className="flex-container padding-15 a-card__darken">
                              <div className="flex-1">
                                <div className="fieldset__title">Length</div>
                                <div className={ length ? "field field--medium field--filled" : "field field--medium"}>
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Length</label>
                                  
                                  { !submitted && <input id="length" type="text" value={length} onFocus={focus} onBlur={blur} onChange={(e) => setNumeric(setLength, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="length" type="text" value={length} onFocus={focus} onBlur={blur} onChange={(e) => setNumeric(setLength, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  
                                  <div className="field__placeholder">Length</div>
                                </div>

                                <div className="fieldset__title">Width</div>
                                <div className={ width ? "field field--medium field--filled" : "field field--medium"}>
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Width</label>
                                  
                                  { !submitted && <input id="width" type="text" value={width} onFocus={focus} onBlur={blur} onChange={(e) => setNumeric(setWidth, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="width" type="text" value={width} onFocus={focus} onBlur={blur} onChange={(e) => setNumeric(setWidth, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  
                                  <div className="field__placeholder">Width</div>
                                </div>
                              </div>

                              <div className="flex-1 left-15">
                                <h4>Unit Measurement</h4>
                                <div className="radio radio--small">
                                  <label for="in">
                                    <input type="radio" name="dimensionMeasurements" value="in" className="" id="in" onChange={(e) => setMeasurements(e)} checked={sizeMeasurement === 'in'} />
                                    <span className="radio-label">
                                      <span className="radio-label-title">in</span>
                                    </span>
                                  </label>
                                </div>
                                <div className="radio radio--small">
                                  <label for="cm">
                                    <input type="radio" name="dimensionMeasurements" value="cm" className="" id="cm" onChange={(e) => setMeasurements(e)} checked={sizeMeasurement === 'cm'} />
                                    <span className="radio-label">
                                      <span className="radio-label-title">cm</span>
                                    </span>
                                  </label>
                                </div>
                                <div className="radio radio--small">
                                  <label for="mm">
                                    <input type="radio" name="dimensionMeasurements" value="mm" className="" id="mm" onChange={(e) => setMeasurements(e)} checked={sizeMeasurement === 'mm'} />
                                    <span className="radio-label">
                                      <span className="radio-label-title">mm</span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                            </div>

                            <div className="flex-container padding-15">
                              <div className="flex-1">

                                <div className="fieldset full-width">
                                  <div className="fieldset__title">Line Count</div>
                                  <div className={ lineCount ? "field field--medium field--filled" : "field field--medium"}>
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Line Count</label>
                                    
                                    { !submitted && <input id="line_count" type="text" value={lineCount || ''} onFocus={focus} onBlur={blur} onChange={(e) => setInteger(changeLineCount, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                    { submitted && <input id="line_count" type="text" value={lineCount || ''} onFocus={focus} onBlur={blur} onChange={(e) => setInteger(changeLineCount, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                    
                                    <div className="field__placeholder">Line Count</div>
                                  </div>
                                </div>

                              </div>

                              { printType === 'roll' &&
                                <div className="flex-1 left-15">
                                  <div className="iconable-block iconable-block--hide-in-mobile">
                                    <div className="iconable-block__infographics">
                                      <span className="iconable-block__icon">
                                        <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M14.7071068,4 L17.5,4 C18.8807119,4 20,5.11928813 20,6.5 L20,9.29289322 L21.1464466,8.14644661 C21.3417088,7.95118446 21.6582912,7.95118446 21.8535534,8.14644661 C22.0488155,8.34170876 22.0488155,8.65829124 21.8535534,8.85355339 L19.8535534,10.8535534 C19.6582912,11.0488155 19.3417088,11.0488155 19.1464466,10.8535534 L17.1464466,8.85355339 C16.9511845,8.65829124 16.9511845,8.34170876 17.1464466,8.14644661 C17.3417088,7.95118446 17.6582912,7.95118446 17.8535534,8.14644661 L19,9.29289322 L19,6.5 C19,5.67157288 18.3284271,5 17.5,5 L14.7071068,5 L15.8535534,6.14644661 C16.0488155,6.34170876 16.0488155,6.65829124 15.8535534,6.85355339 C15.6582912,7.04881554 15.3417088,7.04881554 15.1464466,6.85355339 L13.1464466,4.85355339 C12.9511845,4.65829124 12.9511845,4.34170876 13.1464466,4.14644661 L15.1464466,2.14644661 C15.3417088,1.95118446 15.6582912,1.95118446 15.8535534,2.14644661 C16.0488155,2.34170876 16.0488155,2.65829124 15.8535534,2.85355339 L14.7071068,4 Z M4.5,2 L9.5,2 C10.8807119,2 12,3.11928813 12,4.5 L12,15.5 C12,16.8807119 10.8807119,18 9.5,18 L4.5,18 C3.11928813,18 2,16.8807119 2,15.5 L2,4.5 C2,3.11928813 3.11928813,2 4.5,2 Z M4.5,3 C3.67157288,3 3,3.67157288 3,4.5 L3,15.5 C3,16.3284271 3.67157288,17 4.5,17 L9.5,17 C10.3284271,17 11,16.3284271 11,15.5 L11,4.5 C11,3.67157288 10.3284271,3 9.5,3 L4.5,3 Z M16.5,13 C16.2238576,13 16,12.7761424 16,12.5 C16,12.2238576 16.2238576,12 16.5,12 L17.5,12 C17.7761424,12 18,12.2238576 18,12.5 C18,12.7761424 17.7761424,13 17.5,13 L16.5,13 Z M13.5,13 C13.2238576,13 13,12.7761424 13,12.5 C13,12.2238576 13.2238576,12 13.5,12 L14.5,12 C14.7761424,12 15,12.2238576 15,12.5 C15,12.7761424 14.7761424,13 14.5,13 L13.5,13 Z M16.5,22 C16.2238576,22 16,21.7761424 16,21.5 C16,21.2238576 16.2238576,21 16.5,21 L17.5,21 C17.7761424,21 18,21.2238576 18,21.5 C18,21.7761424 17.7761424,22 17.5,22 L16.5,22 Z M13.5,22 C13.2238576,22 13,21.7761424 13,21.5 C13,21.2238576 13.2238576,21 13.5,21 L14.5,21 C14.7761424,21 15,21.2238576 15,21.5 C15,21.7761424 14.7761424,22 14.5,22 L13.5,22 Z M10.5,22 C10.2238576,22 10,21.7761424 10,21.5 C10,21.2238576 10.2238576,21 10.5,21 L11.5,21 C11.7761424,21 12,21.2238576 12,21.5 C12,21.7761424 11.7761424,22 11.5,22 L10.5,22 Z M19.5,13 C19.2238576,13 19,12.7761424 19,12.5 C19,12.2238576 19.2238576,12 19.5,12 C20.8807119,12 22,13.1192881 22,14.5 C22,14.7761424 21.7761424,15 21.5,15 C21.2238576,15 21,14.7761424 21,14.5 C21,13.6715729 20.3284271,13 19.5,13 Z M21,16.5 C21,16.2238576 21.2238576,16 21.5,16 C21.7761424,16 22,16.2238576 22,16.5 L22,17.5 C22,17.7761424 21.7761424,18 21.5,18 C21.2238576,18 21,17.7761424 21,17.5 L21,16.5 Z M21,19.5 C21,19.2238576 21.2238576,19 21.5,19 C21.7761424,19 22,19.2238576 22,19.5 C22,20.8807119 20.8807119,22 19.5,22 C19.2238576,22 19,21.7761424 19,21.5 C19,21.2238576 19.2238576,21 19.5,21 C20.3284271,21 21,20.3284271 21,19.5 Z M8.5,21 C8.77614237,21 9,21.2238576 9,21.5 C9,21.7761424 8.77614237,22 8.5,22 C7.11928813,22 6,20.8807119 6,19.5 C6,19.2238576 6.22385763,19 6.5,19 C6.77614237,19 7,19.2238576 7,19.5 C7,20.3284271 7.67157288,21 8.5,21 Z"/>
                                        </svg>
                                      </span>
                                    </div>
                                    <div className="iconable-block__content">
                                      <div className="status-block">
                                        <div className="status-block__central">
                                          <div className="status-block__header">
                                            <span className="status-block__title">
                                              Rotate label
                                            </span>
                                          </div>
                                          <div className="status-block__content">
                                            <p>
                                              Rotate the label 90 degrees for labels that are taller than they are wide.
                                            </p>
                                          </div>
                                        </div>
                                        <br/>
                                        <div className="status-block__primary-action">
                                          <label className="checkbox big">
                                            { rotate && <input type="checkbox" checked="true" onClick={() => handleSwitchRotate()}/>}
                                            { !rotate && <input type="checkbox" onClick={() => handleSwitchRotate()}/>}
                                            <div><div></div></div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }

                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="a-card__darken padding-15">
                        <h3>Barcode Row</h3>
                        <div className="flex-table">
                          <div className="flex-table__head">
                            <div className="flex-table__col flex-table__col--align-center">Enabled</div>
                            <div className="flex-table__col flex-table__col--align-center">Line</div>
                            <div className="flex-table__col flex-table__col--align-center">Height % of label</div>
                          </div>
                          <div className="flex-table__row">
                            <div className="flex-table__col flex-table__col--align-center">
                              <label>
                                <input checked={barcodeEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setBarcodeEnabled, barcodeEnabled, 'barcode_enabled')} />
                              </label>
                            </div>
                            <div className="flex-table__col flex-table__col--align-center">

                              <select value={barcodeLine} id="barcode_line" onChange={(e) => setInteger(setBarcodeLine, e)} className="field__select">
                                { lineSettings.map((lineSetting, index) =>
                                  <option value={index} key={index}>{index + 1}</option>
                                )}
                              </select>

                            </div>
                            <div className="flex-table__col flex-table__col--align-center">
                              
                              <div className="fieldset fieldset--with-prefix">
                                <div className="fieldset__field-wrapper">
                                  <div className="field field--medium field--filled">
                                    <span className="fieldset__svg-icon"></span>
                                    <label className="field__label">Height % of label</label>
                                    { !submitted && <input id="barcode_height_percent" type="text" value={barcodeHeightPercent || ''} onFocus={focus} onBlur={blur} onChange={(e) => setInteger(setBarcodeHeightPercent, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                    { submitted && <input id="barcode_height_percent" type="text" value={barcodeHeightPercent || ''} onFocus={focus} onBlur={blur} onChange={(e) => setInteger(setBarcodeHeightPercent, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                    <div className="field__placeholder">Height % of label</div>
                                  </div>
                                  <div className="fieldset__field-suffix">%</div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                      

                      <h3>Label Parts</h3>
                      <div className="flex-table">
                        <div className="flex-table__head">
                          <div className="flex-table__col flex-table__col--align-center">Enabled</div>
                          <div className="flex-table__col flex-table__col--align-center">Label Part</div>
                          <div className="flex-table__col flex-table__col--align-center">Line</div>
                          <div className="flex-table__col flex-table__col--align-center">Include Name</div>
                          <div className="flex-table__col flex-table__col--align-center">Name Override</div>
                        </div>

                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={barcodeSymbolEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setBarcodeSymbolEnabled, barcodeSymbolEnabled, 'barcode_symbol_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Barcode Symbol
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={barcodeSymbolLine} id="barcode_symbol_line" onChange={(e) => setInteger(setBarcodeSymbolLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={barcodeSymbolLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setBarcodeSymbolLabelEnabled, barcodeSymbolLabelEnabled, 'barcode_symbol_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="barcode_symbol_label_override" type="text" value={barcodeSymbolLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setBarcodeSymbolLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="barcode_symbol_label_override" type="text" value={barcodeSymbolLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setBarcodeSymbolLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={productNameEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setProductNameEnabled, productNameEnabled, 'product_name_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Product Name
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={productNameLine} id="product_name_line" onChange={(e) => setInteger(setProductNameLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={productNameLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setProductNameLabelEnabled, productNameLabelEnabled, 'product_name_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="product_name_label_override" type="text" value={productNameLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setProductNameLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="product_name_label_override" type="text" value={productNameLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setProductNameLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={optionOneEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setOptionOneEnabled, optionOneEnabled, 'option_1_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Variation Option 1
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={optionOneLine} id="option_1_line" onChange={(e) => setInteger(setOptionOneLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={optionOneLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setOptionOneLabelEnabled, optionOneLabelEnabled, 'option_1_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="option_1_label_override" type="text" value={optionOneLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setOptionOneLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="option_1_label_override" type="text" value={optionOneLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setOptionOneLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={optionTwoEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setOptionTwoEnabled, optionTwoEnabled, 'option_2_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Variation Option 2
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={optionTwoLine} id="option_2_line" onChange={(e) => setInteger(setOptionTwoLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={optionTwoLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setOptionTwoLabelEnabled, optionTwoLabelEnabled, 'option_2_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="option_2_label_override" type="text" value={optionTwoLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setOptionTwoLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="option_2_label_override" type="text" value={optionTwoLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setOptionTwoLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={optionThreeEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setOptionThreeEnabled, optionThreeEnabled, 'option_3_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Variation Option 3
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={optionThreeLine} id="option_3_line" onChange={(e) => setInteger(setOptionThreeLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={optionThreeLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setOptionThreeLabelEnabled, optionThreeLabelEnabled, 'option_3_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="option_3_label_override" type="text" value={optionThreeLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setOptionThreeLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="option_3_label_override" type="text" value={optionThreeLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setOptionThreeLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={priceEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setPriceEnabled, priceEnabled, 'price_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Price
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={priceLine} id="price_line" onChange={(e) => setInteger(setPriceLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={priceLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setPriceLabelEnabled, priceLabelEnabled, 'price_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="price_label_override" type="text" value={priceLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setPriceLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="price_label_override" type="text" value={priceLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setPriceLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>




                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={taxedPriceEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setTaxedPriceEnabled, taxedPriceEnabled, 'taxed_price_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Taxed Price
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={taxedPriceLine} id="taxed_price_line" onChange={(e) => setInteger(setTaxedPriceLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={taxedPriceLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setTaxedPriceLabelEnabled, taxedPriceLabelEnabled, 'taxed_price_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="taxed_price_label_override" type="text" value={taxedPriceLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setTaxedPriceLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="taxed_price_label_override" type="text" value={taxedPriceLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setTaxedPriceLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>




                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={brandEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setBrandEnabled, brandEnabled, 'brand_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            Brand
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={brandLine} id="brand_line" onChange={(e) => setInteger(setBrandLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={brandLabelEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setBrandLabelEnabled, brandLabelEnabled, 'brand_label_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Name Override</label>
                                  { !submitted && <input id="brand_label_override" type="text" value={brandLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setBrandLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="brand_label_override" type="text" value={brandLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setBrandLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Name Override</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                  </div>
                </div>


                <div className="a-card a-card--compact">
                  <div className="a-card__paddings">
                    <h3>Store Branding</h3>

                    <div className="muted">
                      Set your store logo in <Link to="/store_settings">app settings</Link>.
                    </div>

                    <div className="a-card__darken padding-15">
                      <h4>Store Logo Row</h4>
                      <div className="flex-table">
                        <div className="flex-table__head">
                          <div className="flex-table__col flex-table__col--align-center">Enabled</div>
                          <div className="flex-table__col flex-table__col--align-center">Line</div>
                          <div className="flex-table__col flex-table__col--align-center">Height % of label</div>
                        </div>
                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={storeLogoEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setStoreLogoEnabled, storeLogoEnabled, 'store_logo_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <select value={storeLogoLine} id="barcode_line" onChange={(e) => setInteger(setStoreLogoLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>

                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            
                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Height % of label</label>
                                  { !submitted && <input id="store_logo_height_percent" type="text" value={storeLogoHeightPercent || ''} onFocus={focus} onBlur={blur} onChange={(e) => setInteger(setStoreLogoHeightPercent, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="store_logo_height_percent" type="text" value={storeLogoHeightPercent || ''} onFocus={focus} onBlur={blur} onChange={(e) => setInteger(setStoreLogoHeightPercent, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Height % of label</div>
                                </div>
                                <div className="fieldset__field-suffix">%</div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="padding-15">
                      <h4>Brand Text</h4>
                      <div className="flex-table">
                        <div className="flex-table__head">
                          <div className="flex-table__col flex-table__col--align-center">Enabled</div>
                          <div className="flex-table__col flex-table__col--align-center">Line</div>
                          <div className="flex-table__col flex-table__col--align-center">Text</div>
                        </div>

                        <div className="flex-table__row">
                          <div className="flex-table__col flex-table__col--align-center">
                            <label>
                              <input checked={arbitraryTextEnabled} type="checkbox" value="on" tabindex="0" onClick={() => switchBoolean(setArbitraryTextEnabled, arbitraryTextEnabled, 'arbitrary_text_enabled')} />
                            </label>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">
                            <select value={arbitraryTextLine} id="arbitrary_text_line" onChange={(e) => setInteger(setArbitraryTextLine, e)} className="field__select">
                              { lineSettings.map((lineSetting, index) =>
                                <option value={index} key={index}>{index + 1}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex-table__col flex-table__col--align-center">

                            <div className="fieldset fieldset--with-prefix">
                              <div className="fieldset__field-wrapper">
                                <div className="field field--medium field--filled">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Text</label>
                                  { !submitted && <input id="arbitrary_text_label_override" type="text" value={arbitraryTextLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setArbitraryTextLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id="arbitrary_text_label_override" type="text" value={arbitraryTextLabelOverride} onFocus={focus} onBlur={blur} onChange={(e) => setFieldValue(setArbitraryTextLabelOverride, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  <div className="field__placeholder">Text</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="a-card a-card--compact">
                  <div className="a-card__paddings">
                    <h3>Line Settings</h3>
                    <SlTabGroup placement="start">
                      <SlTab slot="nav" panel="disabled" disabled>
                        Select a Line Number
                      </SlTab>

                      { lineSettings.map((lineSetting, index) => 
                          <SlTab slot="nav" panel={`panel-${index}`}>
                            {index + 1}
                          </SlTab>
                        
                      )}

                      <SlTabPanel name="disabled">Select a line number to modify the order that selected label parts appear in.</SlTabPanel>
                      { lineSettings.map((lineSetting, index) => 
                          <SlTabPanel name={`panel-${index}`}>
                            <div className="bottom-15">
                              <h4>Placement</h4>

                              <div className="fieldset__title">Text Alignment</div>

                              <div className="graphic-radio-group">
                                <div className="graphic-radio-group__items">
                                  <div className="graphic-radio graphic-radio--small">
                                    <label className="graphic-radio__label">
                                      <input 
                                        type="radio" 
                                        name={`text_align_${index}`} 
                                        value="left" 
                                        checked={lineSetting.alignment === "left"}
                                        className="graphic-radio__input" 
                                        onChange={ (e) => setAlignment(lineSetting.position, e) }
                                      />
                                      <div className="graphic-radio__icon">
                                        <span className="svg-icon">
                                          <SlIcon name="align-start" />
                                        </span>
                                        <div className="graphic-radio__bg"></div>
                                      </div>
                                      <span className="graphic-radio__title">Align Left</span>
                                    </label>
                                  </div>
                                  <div className="graphic-radio graphic-radio--small">
                                    <label className="graphic-radio__label">
                                      <input 
                                        type="radio" 
                                        name={`text_align_${index}`} 
                                        value="center" 
                                        checked={lineSetting.alignment === "center"}
                                        className="graphic-radio__input" 
                                        onChange={ (e) => setAlignment(lineSetting.position, e) }
                                      />
                                      <div className="graphic-radio__icon">
                                        <span className="svg-icon">
                                          <SlIcon name="align-center" />
                                        </span>
                                        <div className="graphic-radio__bg"></div>
                                      </div>
                                      <span className="graphic-radio__title">Align Center</span>
                                    </label>
                                  </div>
                                  <div className="graphic-radio graphic-radio--small">
                                    <label className="graphic-radio__label">
                                      <input 
                                        type="radio" 
                                        name={`text_align_${index}`} 
                                        value="right" 
                                        checked={lineSetting.alignment === "right"}
                                        className="graphic-radio__input" 
                                        onChange={ (e) => setAlignment(lineSetting.position, e) }
                                      />
                                      <div className="graphic-radio__icon">
                                        <span className="svg-icon">
                                          <SlIcon name="align-end" />
                                        </span>
                                        <div className="graphic-radio__bg"></div>
                                      </div>
                                      <span className="graphic-radio__title">Align Right</span>
                                    </label>
                                  </div>
                                </div>
                              </div>


                              <div className="radio radio--small">
                                <label for="truncate" onClick={ (e) => setRenderStrategy(lineSetting.position, "truncate") }>
                                  <input 
                                    type="radio" 
                                    name={`overflow${index}`} 
                                    value="truncate" 
                                    id={`truncate${index}`} 
                                    className=""
                                    checked={lineSetting.render_strategy === "truncate" || !lineSetting.render_strategy}
                                  />
                                  <span className="radio-label">
                                    <span className="radio-label-title">Truncate</span>
                                  </span>
                                </label>
                              </div>
                              <div className="radio radio--small">
                                <label for="wrap" onClick={ (e) => setRenderStrategy(lineSetting.position, "wrap") }>
                                  <input 
                                    type="radio" 
                                    name={`overflow${index}`} 
                                    value="wrap" 
                                    id={`wrap${index}`}  
                                    className=""
                                    checked={lineSetting.render_strategy === "wrap"}
                                  />
                                  <span className="radio-label">
                                    <span className="radio-label-title">Wrap</span>
                                  </span>
                                </label>
                              </div>
                              <div className="radio radio--small">
                                <label for="shrink" onClick={ (e) => setRenderStrategy(lineSetting.position, "shrink") }>
                                  <input 
                                    type="radio" 
                                    name={`overflow${index}`} 
                                    value="shrink" 
                                    id={`shrink${index}`} 
                                    className=""
                                    checked={lineSetting.render_strategy === "shrink"}
                                  />
                                  <span className="radio-label">
                                    <span className="radio-label-title">Shrink-To-Fit</span>
                                  </span>
                                </label>
                              </div>



                              <div className="fieldset full-width">
                                <div className="fieldset__title">Font Size</div>
                                <div className={ lineSetting.font_size ? "field field--medium field--filled" : "field field--medium"}>
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Font Size</label>
                                  
                                  { !submitted && <input id={`setting_font_size_${index}`} type="text" value={lineSetting.font_size || ''} onFocus={focus} onBlur={blur} onChange={(e) => setFontSize(lineSetting.position, e)} className="field__input" tabindex="4" maxlength="64" /> }
                                  { submitted && <input id={`setting_font_size_${index}`} type="text" value={lineSetting.font_size || ''} onFocus={focus} onBlur={blur} onChange={(e) => setFontSize(lineSetting.position, e)} className="field__input" tabindex="4" maxlength="64" disabled /> }
                                  
                                  <div className="field__placeholder">Font Size</div>
                                </div>
                              </div>

                            </div>
                            <div>
                              <h4>Order</h4>

                              <TemplateLineOrderContainer
                                barcode={barcodeEnabled && (index === barcodeLine)}
                                storeLogo={storeLogoEnabled && (index === storeLogoLine)}
                                
                                barcodeSymbol={barcodeSymbolEnabled && (index === barcodeSymbolLine)}
                                productName={productNameEnabled && (index === productNameLine)}
                                optionOne={optionOneEnabled && (index === optionOneLine)}
                                optionTwo={optionTwoEnabled && (index === optionTwoLine)}
                                optionThree={optionThreeEnabled && (index === optionThreeLine)}
                                price={priceEnabled && (index === priceLine)}

                                taxedPrice={taxedPriceEnabled && (index === taxedPriceLine)}

                                brand={brandEnabled && (index === brandLine)}
                                arbitraryText={arbitraryTextEnabled && (index === arbitraryTextLine)}

                                barcodeSymbolPriority={barcodeSymbolPriority}
                                productNamePriority={productNamePriority}
                                optionOnePriority={optionOnePriority}
                                optionTwoPriority={optionTwoPriority}
                                optionThreePriority={optionThreePriority}
                                pricePriority={pricePriority}

                                taxedPricePriority={taxedPricePriority}

                                brandPriority={brandPriority}
                                arbitraryTextPriority={arbitraryTextPriority}

                                increasePriority={increasePriority}
                                decreasePriority={decreasePriority}
                              />

                            </div>
                          </SlTabPanel>
                        
                      )}
                    </SlTabGroup>
                  </div>
                </div>

                <div className="a-card a-card--compact">
                  <div className="a-card__paddings">
                    { !submitted && validTemplate && <button className="btn btn-primary btn-medium" onClick={() => handleSubmit()}>Save Template</button> }
                    { !submitted && !validTemplate && <button className="btn btn-primary btn-medium" disabled>Save Template</button> }
                    { submitted && <button className="btn btn-primary btn-medium btn-loading" disabled>Save Template</button> }

                    { !templateSaved && 
                      <div className="canonical-status canonical-status--warning left-15">Template changes have not been saved</div>
                    }
                    { (validationErrors.length > 0) &&
                      <>
                        <br/>
                        { validationErrors.map((error) =>
                          <>
                            <br/>
                            <div className="canonical-status canonical-status--error">
                              {error} 
                            </div>
                          </>
                        )}
                        <br/>
                      </>
                    }
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

      </div>
    </>
  )
}

const mapStateToProps = state => ({
  barcodeTemplates: state.barcodeTemplates,
  newTemplate: state.barcodeTemplates.newTemplate,
  settings: state.settings.settings,
});

const mapDispatchToProps = (dispatch) => ({
  newBarcodeTemplate: (payload, options) => dispatch(createBarcodeTemplate(payload, options)),
  loadPreview: (payload, options, values) => dispatch(previewBarcodeTemplate(payload, options, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewTemplateForm);